import { Component, Input, OnInit, ViewChild, viewChild } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { CustomFlexLayoutModule } from '../../../../../../../flex-layout/custom-flex-layout.module';
import { CommonService } from '../../../../../../../services/common.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'calsoft-menu2',
  imports: [MatMenu, MatMenuItem, MatMenuTrigger, CustomFlexLayoutModule],
  templateUrl: './menu2.component.html',
  styleUrl: './menu2.component.scss'
})
export class Menu2Component implements OnInit {
   @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;  // Use ! since it will be set after view init
  @ViewChild('menu') menu!: MatMenu;

  @Input() items$:any=[];
  @Input() display: any=false;
  
  @Input() data: any;
  constructor(   private commonService: CommonService,) { }

  ngOnInit(): void {
  }
  getDouble(children$: Observable<string[]>): Observable<string[]> {
    return children$.pipe(map(children => [...children, ...children]));
  }

  goToCategory(menu:any) {

    

    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);

  }

  closeMyMenu(){
    this.trigger.closeMenu();
   // console.log('close')
  }

  timedOutCloser:any;

  readonly clickHoverMenuTrigger:any = viewChild<MatMenuTrigger>('clickHoverMenuTrigger');
 mouseEnter() {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    this.trigger.openMenu();
  }

  mouseLeave() {
    this.timedOutCloser = setTimeout(() => {
      this.trigger.closeMenu();
    }, 50);
  }


  menuenter() {
    this.mouseEnter();
  }

  menuLeave(levelOneTrigger: MatMenuTrigger, button: HTMLElement) {
  // Now button is native HTMLElement
  // Use as needed, e.g.:
  console.log(button); // Should be the HTMLAnchorElement or whatever element triggered mouseleave
  this.mouseLeave();
}


}
